import { Nullable } from "../../../@types/util";

export type YesNoUndefinedType = "yes" | "no" | undefined;

class YesNoType {
  private static ALL_VALUES: YesNoType[] = [];

  static readonly YES = new YesNoType("yes", "Yes");

  static readonly NO = new YesNoType("no", "No");

  constructor(
    public readonly value: YesNoUndefinedType,
    public readonly label: string,
    public readonly inline: boolean = true,
    public readonly className: string = "ms-2"
  ) {
    YesNoType.ALL_VALUES.push(this);
  }

  static values(): YesNoType[] {
    return YesNoType.ALL_VALUES;
  }

  static valueOf(targetValue: Nullable<string>): YesNoType | undefined {
    return YesNoType.ALL_VALUES.find(({ value }) => value === targetValue);
  }

  static parseBoolean(value: Nullable<string>): boolean | undefined {
    return value === this.YES.value;
  }

  static parseValue(booleanValue: Nullable<boolean>): YesNoUndefinedType {
    if (booleanValue === true) {
      return this.YES.value;
    }
    if (booleanValue === false) {
      return this.NO.value;
    }
    return undefined;
  }
}

export default YesNoType;
